module.exports = __webpack_public_path__ + "img/05.d8527000.jpg";